import { Module } from 'vuex'
import _ from 'lodash'

import { PTRootState } from '@pt/store/index.type'
import { ResourceState, assetFontListItem } from './index.type'
import { assetsList } from '@pt/api/assets'

const assetsResourceModule: Module<ResourceState, PTRootState> = {
  namespaced: true,

  state: {
    assetFontList: [],
  },

  mutations: {},

  actions: {
    async getAssetFontList({ state }) {
      const res = await assetsList({
        page: 1,
        page_size: 1000,
        types: ['font'],
        formats: ['ttf', 'otf'],
      })
      const list = _.get(res, 'data.data.list') || []
      const returnList: assetFontListItem[] = []
      _.map(list, (item) => {
        const payload = JSON.parse(item.payload)
        returnList.push({
          id: item.id,
          label: payload.postscript_name || '',
          svg: item.cover_url,
          url: item.full_url,
          value: item.id + '|' + payload.postscript_name,
        })
      })
      state.assetFontList = returnList
      return returnList
    },
  },
}

export default assetsResourceModule
